module.exports = __webpack_public_path__ + "img/img5.9953756b.png";